import script from "./AccountSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&setup=true&lang=ts"

import "./AccountSettings.vue?vue&type=style&index=0&id=8d3ff398&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d3ff398"]])

export default __exports__